export default __webpack_public_path__ + "static/stationWagon-37d1a03214c6bbba7ba9c1d41e40ed72.svg";